<template>
  <div class="vslider">
    <v-slider
      v-if="!is_range"
      v-model="model"
      :tick-labels="labels"
      :step="step"
      :max="max"
      :min="min || 0"
      :label="label"
      :color="color"
      :tick-size="tickSize"
      :track-color="trackColor"
      :disabled="disabled"
      :thumb-size="thumbSize"
      ticks="always"
      @change="change"
    />

    <v-range-slider
      v-else
      v-model="model"
      :tick-labels="labels"
      :tick-size="tickSize"
      ticks="always"
      :min="min || 0"
      :max="max"
      :color="color"
      thumb-size="12"
      :track-color="trackColor"
      :disabled="!!disabled"
      :readonly="!!readonly"
    />
  </div>
</template>

<script>
export default {
  name: 'Vslider',

  props: {
    value: [String, Number],
    labels: Array,
    label: {
      type: String,
      default: ''
    },

    step: [String, Number],
    max: [String, Number],
    min: [String, Number],
    size: [String, Number],
    is_range: Boolean,
    disabled: {
      type: Boolean,
      default: false
    },

    readonly: Boolean,
    color: {
      type: String,
      default: '#00d26e'
    },

    trackColor: {
      type: String,
      default: '#ffffff'
    },

    tickSize: {
      type: [String, Number],
      default: 0
    },

    thumbSize: {
      type: [String, Number],
      default: 12
    }
  },

  computed: {
    model: {
      get() {
        return this.value;
      },

      set(val) {
        this.$emit('set_value', val);
      }
    }
  },

  methods: {
    change(ev) {
      this.$emit('change', ev);
    }
  }
};
</script>

<style lang="scss">
@import '@/styles/variables.scss';

.vslider {
  .v-slider--horizontal {
    .v-slider__track-container {
      height: 4px;

      .v-slider__track-fill {
        border: 1px solid $green !important;
        border-top-left-radius: 6px !important;
        border-bottom-left-radius: 6px !important;
      }

      .v-slider__track-background {
        border: 1px solid $green !important;
        border-top-right-radius: 6px !important;
        border-bottom-right-radius: 6px !important;
      }
    }

    .v-slider__thumb {
      top: 1px;
    }

    .v-slider__tick-label {
      font-size: 13px;
      color: #999;
      top: 10px;
    }

    .v-label {
      font-size: 14px;
    }
  }
}
</style>
